var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineStore } from "pinia";
import CampaignControllerActionCreativeEndpoints from "src/shared/api/campaign/controller/action/creative/CampaignControllerActionCreativeEndpoints";
import { campaignChangeEvent } from "src/shared/store/event-bus/campaign";
const convertToUpdateRequest = (mutable) => {
    return {
        quality: mutable.quality,
        enabled: mutable.enabled,
        component_ids: mutable.component_ids,
        classification: mutable.classification,
        api_version: mutable.api_version,
        theme_version: mutable.theme_version,
    };
};
export const useCampaignControllerActionCreativeStore = defineStore("campaignControllerActionCreativeStore", () => {
    const uploadCreative = (parameters) => __awaiter(void 0, void 0, void 0, function* () {
        yield CampaignControllerActionCreativeEndpoints.uploadCreative(parameters.campaignId, parameters.controllerId, parameters.actionId, parameters.file);
        campaignChangeEvent.emit({ campaignId: parameters.campaignId });
    });
    const update = (parameters) => __awaiter(void 0, void 0, void 0, function* () {
        yield CampaignControllerActionCreativeEndpoints.update(parameters.campaignId, parameters.stepId, parameters.actionId, convertToUpdateRequest(parameters.mutable));
        campaignChangeEvent.emit({ campaignId: parameters.campaignId });
    });
    const removeFromComponent = (parameters) => __awaiter(void 0, void 0, void 0, function* () {
        yield CampaignControllerActionCreativeEndpoints.update(parameters.campaignId, parameters.stepId, parameters.actionId, {
            component_ids: [],
        });
        campaignChangeEvent.emit({ campaignId: parameters.campaignId });
    });
    const addToComponent = (parameters) => __awaiter(void 0, void 0, void 0, function* () {
        yield CampaignControllerActionCreativeEndpoints.update(parameters.campaignId, parameters.stepId, parameters.actionId, {
            component_ids: [parameters.componentId],
        });
        campaignChangeEvent.emit({ campaignId: parameters.campaignId });
    });
    return {
        uploadCreative,
        update,
        removeFromComponent,
        addToComponent,
    };
});
